var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FAQ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.97506 18.7839C14.5776 18.7839 18.3084 15.053 18.3084 10.4505C18.3084 5.84802 14.5776 2.11719 9.97506 2.11719C5.37256 2.11719 1.64172 5.84802 1.64172 10.4505C1.64172 15.053 5.37256 18.7839 9.97506 18.7839Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.08337 4.55664L7.03337 7.49831M4.08337 16.34L7.03337 13.3983M15.875 16.34L12.925 13.3983M15.875 4.55664L12.925 7.49831M10 14.1983C10.9946 14.1983 11.9484 13.8032 12.6517 13.1C13.355 12.3967 13.75 11.4429 13.75 10.4483C13.75 9.45375 13.355 8.49992 12.6517 7.79666C11.9484 7.0934 10.9946 6.69831 10 6.69831C9.00548 6.69831 8.05165 7.0934 7.34839 7.79666C6.64513 8.49992 6.25004 9.45375 6.25004 10.4483C6.25004 11.4429 6.64513 12.3967 7.34839 13.1C8.05165 13.8032 9.00548 14.1983 10 14.1983Z",
    stroke: "#84818A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.35dfda77331aef5264a7d6e07900be69.svg";
export { ForwardRef as ReactComponent };